import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const viewRole = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('employee-management/role-management', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const activeRole = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('role/active', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const addRole = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('employee-management/role-management/add', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const getRole = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('employee-management/role-management/edit/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const editRole = (id, data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('employee-management/role-management/update/' + id, token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const toggleRole = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('employee-management/role-management/status/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
